import React, { useState } from 'react';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import cn from 'classnames';

export interface IBlockQuoteProps extends IBaseElementProps {
	quote?: string;
}

/**
 * Calian Block Quote
 * @icon format-gallery
 * @block
 */
const BlockQuote: React.FC<IBlockQuoteProps> = ({
	id,
	className,
	classNames = [],
	quote,
}) => {
	return (
		<div
			id={id}
			className={className || cn('calian-block-quote', ...classNames)}
		>
			{quote && (
				<blockquote className="calian-block-quote__quote position-relative mx-auto px-4 ps-8 ps-md-4">
					{quote}
				</blockquote>
			)}
		</div>
	);
};
export default BlockQuote;
